import { ComponentRenderHooks } from "@/plugins/types";
import LiveButton from "./component";
import { ComponentTypes } from "@/Apps/Pages/Editor/types";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === ComponentTypes.V1BUTTON) {
    return [LiveButton];
  }
};
